export const PAYMENT_TILES = [
    {
      SK:"invoice",
      label: "Invoice Payment",
      page: ""
    },
    {
      SK: "donations",
      label: "Donations",
      page: "Donations",
      
    },
    {
      SK:"other-payments",
      label: "Non-Invoice Payment",
      page: "Misc"
    },
    {
      SK:"enablensw",
      label: "EnableNSW",
      page: ""
    }
  ]
  
  export const COUNTRIES_LIST = [
      { value: "AR", text: "Argentina" },
      { value: "BD", text: "Bangladesh" },
      { value: "BE", text: "Belgium" },
      { value: "BR", text: "Brazil" },
      { value: "CA", text: "Canada" },
      { value: "CH", text: "Switzerland" },
      { value: "CN", text: "China" },
      { value: "DE", text: "Germany" },
      { value: "ES", text: "Spain" },
      { value: "FR", text: "France" },
      { value: "GB", text: "United Kingdom" },
      { value: "GR", text: "Greece" },
      { value: "ID", text: "Indonesia" },
      { value: "IN", text: "India" },
      { value: "IT", text: "Italy" },
      { value: "MY", text: "Malaysia" },
      { value: "NO", text: "Norway" },
      { value: "NZ", text: "New Zealand" },
      { value: "PH", text: "Philippines" },
      { value: "PT", text: "Portugal" },
      { value: "SE", text: "Sweden" },
      { value: "SG", text: "Singapore" },
      { value: "TH", text: "Thailand" },
      { value: "US", text: "United States" },
    ];